import React from 'react';
import { Link } from "react-router-dom";

const Button = (props) => {
    return (
        <React.Fragment>

            <div className="grid">

                <button className="colorful-button dark" style={{ fontFamily: "BYekan" }}>
                    <div className="wrapper">
                        <Link to={`/article/${props.idArticle}`} style={{ color: "white" }} >
                            <span>مشاهده ی مقاله</span>
                            <div className="circle circle-12"></div>
                            <div className="circle circle-11"></div>
                            <div className="circle circle-10"></div>
                            <div className="circle circle-9"></div>
                            <div className="circle circle-8"></div>
                            <div className="circle circle-7"></div>
                            <div className="circle circle-6"></div>
                            <div className="circle circle-5"></div>
                            <div className="circle circle-4"></div>
                            <div className="circle circle-3"></div>
                            <div className="circle circle-2"></div>
                            <div className="circle circle-1"></div>
                        </Link>
                    </div>
                </button>

            </div>




        </React.Fragment>

    )
}
export default Button;